import { createWeb3Modal, defaultConfig } from "@web3modal/ethers/react";
const projectId = "9ec0499d8df3f191b0c62e628a4ff961"; // key

// not change, change lo ma fix
export const networkArr = [
  // {
  //   image: 'https://testapi.nft.pionewallet.com/image/icon/bnb.png',
  //   id: 1,
  //   name: 'Binance Smart Chain (testnet)',
  //   short_name: 'BNB',
  //   key: 'BEP-20',
  //   currency: 'tBNB',
  //   rpcUrl: 'https://data-seed-prebsc-1-s1.bnbchain.org:8545',
  //   chainId: 97,
  //   decimals: 18,
  //   explorerUrl: 'https://testnet.bscscan.com',
  //   active: true
  // },
  {
    image: "https://testapi.nft.pionewallet.com/image/icon/pio.png",
    id: 4,
    name: "Pione Zero Scan",
    short_name: "PZO",
    key: "BZO-20",
    currency: "PZO",
    rpcUrl: "https://rpc.zeroscan.org/",
    chainId: 5080,
    decimals: 18,
    explorerUrl: "https://zeroscan.org",
    active: true,
  },

  //   {
  //     image: "https://testapi.nft.pionewallet.com/image/icon/bnb.png",
  //     id: 3,
  //     name: "Binance Smart Chain",
  //     short_name: "BNB",
  //     key: "BEP-20",
  //     currency: "BNB",
  //     rpcUrl: "https://bsc-dataseed.binance.org/",
  //     chainId: 56,
  //     decimals: 18,
  //     explorerUrl: "https://bscscan.com",
  //     active: true,
  //   },
  //   {
  //     image: "https://testapi.nft.pionewallet.com/image/icon/pio.png",
  //     id: 2,
  //     name: "Pione Chain",
  //     short_name: "PIO",
  //     key: "PIO-20",
  //     currency: "PIO",
  //     rpcUrl: "https://rpc.pionescan.com/",
  //     chainId: 5090,
  //     decimals: 18,
  //     explorerUrl: "https://pionescan.com",
  //     active: true,
  //   },
];

const metadata = {
  name: "Pione Care",
  description: "Pione Care",
  url: "https://pionecare.com/",
  icons: [
    "https://nft.pionewallet.com/static/media/iconFooter.4abbaabff943c1e11dcf.png",
  ],
};

const ethersConfig = defaultConfig({
  metadata,
  chains: networkArr,
  enableEIP6963: true,
  enableInjected: true,
  enableCoinbase: true,
  rpcUrl: "https://rpc.pionescan.org/",
  defaultChainId: 5090,
  auth: {
    socials: [],
    email: false,
  },
});

// const ethersConfig = defaultConfig({
//   metadata,
//   enableEIP6963: true,
//   enableInjected: true,
//   enableCoinbase: true,
//   rpcUrl: 'https://rpc.zeroscan.org/',
//   defaultChainId: 5080,
//   auth: {
//     socials: [],
//     email: false
//   }
// })

createWeb3Modal({
  ethersConfig,
  chains: networkArr,
  projectId,
  enableAnalytics: true,
  enableOnramp: false,
  enableSwaps: false,

  themeMode: "dark",
  themeVariables: {
    "--w3m-accent": "#29c9fe",
    "--w3m-background": "#29c9fe",
    "--w3m-z-index": 1222,
  },
  customWallets: [
    {
      id: "com.companyname.swaptobe",
      name: "PioneWallet",
      homepage: "com.companyname.swaptobe",
      image_url: "https://pionescan.com/favicon/favicon.png",
      mobile_link: "tobewallet://",
      desktop_link: "desktop_link",
      webapp_link: "webapp_link",
      app_store: "app_store",
      play_store:
        "https://play.google.com/store/apps/details?id=com.companyname.swaptobe",
    },
  ],
});

export function Web3Modal({ children }) {
  return children;
}
